// blog/news 본문 및 CMS CTA 에서 공유하는 pill(캡슐) 버튼 스타일.
// 앵커(CtaButton)는 여기에 `no-underline` 을 덧붙여 쓴다.
export const CTA_PILL_CLASSNAME =
  'rounded-[100px] bg-3b-blue-light-900 px-[70px] py-[14px] text-body1 font-semibold';

export const CTA_PILL_TEXT_CLASSNAME = 'text-3b-text-contrast';
